import { render, staticRenderFns } from "./SubmitCodeExercise.vue?vue&type=template&id=c28ef7a2&scoped=true&"
import script from "./SubmitCodeExercise.vue?vue&type=script&lang=js&"
export * from "./SubmitCodeExercise.vue?vue&type=script&lang=js&"
import style0 from "./SubmitCodeExercise.vue?vue&type=style&index=0&id=c28ef7a2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c28ef7a2",
  null
  
)

export default component.exports